import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ViewCell } from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';
import  moment from 'moment';
import { DateColumn } from '../../ng2-smart-table/lib/data-set/date-column';
import { DATE_SERVICE_INTERFACE, IDateService } from '@app/@core/services/interfaces/i-date-service.inteface';
import { Subscription } from 'rxjs';
@Component({
    selector: 'de-date-time-cell',
    template: '<span>{{renderValue}}</span>',
    styleUrls: ['./date-time-cell.component.scss'],
    standalone: false
})
export class DateTimeCellComponent implements ViewCell, OnInit, OnDestroy {
  renderValue: string;

  @Input() value: string | number;
  @Input() status: string | number;
  @Input() rowData: any;
  @Input() settings: DateColumn;
  subscriptions: Array<Subscription> = [];

  constructor(
    @Inject(DATE_SERVICE_INTERFACE) private dateService: IDateService) { }

  ngOnInit() {
    if (this.value) {
      this.subscriptions.push(
        this.dateService.getDateFormat().subscribe(format => {
          if (this.settings.isFullDateTime) {
            format += ' hh:mm:ss A'
          }

          this.renderValue = moment(this.value).format(format);
        })
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
